import { Fragment } from "react";
import { Grid, Typography } from "@mui/material";

import { Breadcrumbs, PageHeader, Spinner } from "@dzambalaorg/mui-page-layout";
import { RichTextDisplay } from "@dzambalaorg/mui-rte";
import type { IMysteryBox } from "@framework/types";
import { useFetchData } from "@dzambalaorg/react-hooks";

import { MysteryBoxContent } from "../token/mysterybox-content";
import { MysteryBoxPanel } from "./mystery-box-panel";
import { StyledImage } from "./styled";

export const MysteryBox = () => {
  const { data, isLoading } = useFetchData<IMysteryBox>("/erc721/tokens");

  if (isLoading) {
    return <Spinner />;
  }

  if (!data) {
    // TODO - [AFTER ALL REFACTORING] - add universal no data component
    return <div>No data</div>;
  }

  return (
    <Fragment>
      <Breadcrumbs path={["dashboard", "mystery", "mystery.box"]} data={[{}, {}, data]} />

      <PageHeader message="pages.mystery.box.title" data={data} />

      <Grid container>
        <Grid size={{ xs: 12, sm: 9 }}>
          <StyledImage component="img" src={data.imageUrl} />
          <Typography variant="body2" color="textSecondary" component="div">
            <RichTextDisplay data={data.description} />
          </Typography>
        </Grid>
        <Grid size={{ xs: 12, sm: 3 }}>
          {data.templateId ? (
            <>
              <MysteryBoxPanel box={data} />
            </>
          ) : null}
        </Grid>

        <Grid size={{ xs: 3 }}></Grid>
      </Grid>

      <MysteryBoxContent mysteryBox={data} />
    </Fragment>
  );
};
